<template>
  <!-- <div
    class="panel bg-white rounded-xl space-y-6 p-6 ml-3 mt-3"
    @mouseover="showReport()"
    @mouseout="hideReport()"
  > -->
  <div
    class="panel d2-report-chart-card"
  >
    <h5 class="d2-report-chart-title">{{ title }}</h5>
    <Chart
      type="horizontalBar"
      :data="lineStylesData"
      :options="basicOptions"
      style="margin-top:25px;"
      :style="{height: `${allHieght}px`}"
    />
    <MaterialChartReport :tableShow="reportShow" :tableData="finTableData" :lang="langData" v-bind:listKey="listKey" />
  </div>
</template>

<script>

import { ref, computed, watch } from 'vue';
import MaterialChartReport from './MaterialChartReport.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'

export default {
  name: 'ChartPanel',
  props: {
    title: {
      type: String,
      default: 'xxx'
    },
    allHieght: {
      type: Number
    },
    chartPrview:{
      type: Array,
      default: () => []
    },
    chartsData: {
      type: Object,
      default: () => ({
        labels: [],
        datasets: []
      })
    },
    tableData: {
      type: Array,
      default: () => []
    },
    lang: {
      type: Object
    }
  },
  components: {
    MaterialChartReport
  },
  setup(props) {
    const reportShow = ref(true);
    const listKey = ref('');

    //console.log('props.lang');
    //console.log(props.lang);

    // const basicOptions = computed(() => ({
    //   legend: {
    //     position: 'bottom',
    //     /* eslint-disable */
    //     onClick: function(e, legendItem) {
    //       let index = legendItem.datasetIndex;
    //       let ci = this.chart;
    //       let meta = ci.getDatasetMeta(index);

    //       // See controller.isDatasetVisible comment
    //       if (legendItem.text !== undefined && legendItem.text !== '優化建議') {
    //         meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;
    //       }
    //       // We hid a dataset ... rerender the chart
    //       ci.update();
    //     },
    //     /* eslint-disable */
    //     labels: {
    //       filter: function(e) {
    //         return e.text !== undefined;
    //       }
    //     }
    //   },
    //   tooltips: {
    //     mode: 'index',
    //     // intersect: false,
    //     position: 'nearest',
    //     filter: function(e) {
    //       const optimizeDatasetsCounts = props.tableData.length * 2;
    //       return e.datasetIndex >= optimizeDatasetsCounts;
    //     }
    //   },
    //   plugins: {
    //     legend: {
    //       labels: {
    //         color: '#495057'
    //       }
    //     }
    //   },
    //   scales: {
    //     xAxes: [{
    //       type: 'time',
    //       time: {
    //         unit: 'month',
    //         displayFormats: {
    //           month: 'YYYY/MM/DD'
    //         }
    //       }
    //     }],
    //     x: {
    //       ticks: {
    //         color: '#f02222',
    //       },
    //     },
    //     y: {
    //       ticks: {
    //         color: '#f02222'
    //       },
    //     }
    //   }
    // }));

    // const materialList = props.chartPrview;
    // const materialList = computed(() => {
    //   // chartRef.value.update();
    //   console.log('in props.chartPrview');
    //   console.log(props.chartPrview);
    //   return props.chartPrview
    // });

    // console.log('materialList');
    // console.log(materialList);
    // console.log('props.chartPrview');
    // console.log(props.chartPrview);

    // const materialList = {
    //   "0_素材0001":{
    //     "title":"a素材",
    //     "content":"<iframe src=\"https://www.facebook.com/ads/api/preview_iframe.php?d=AQIygHkEZxnL2TBX0BwppIU23aqdGfP2QWikm2qIk5-jXqk-NxFd5Y7BGyL5Y_NGmWD-FWZBeV4fWdGIdlwUYsAPG6Ovivjg9OfGdb_z1GlNSmyFRnTh6loT-A--XFWwiPiSV-mCxMqseeW9sHdqZKxYHFyjzPRzY7g1pBXvcCsNFqIsuOIw7DX4W2SQo1CrJ6JlRI9dHI3lvNLCQyHskOqbbwRdMdcvUY3sqcvHd4b8sD-SJrCHIYBaN5GeWaVbH7P6JSTbDITzfkNKnqO5s-8xErJfbO_H-3C-SJPQ6UKYSMMHW2s8FwmMRz9kfft4jxCH7_7eigzv3EbmSB8LSy4XdxwUmEsHcsiKI27r5gseNRG7wQYtsLN8y_p1enhS4mwODlHWCsysDswkjOin2k0ASwY0Ks_mc2Lv-GdhGgb5Z4baWJaQKiHPS4KLpyV6yCfyGUe8WVvDKhwl1txoO73mh-vZpKWJSROvCzMKMlyOxg_lmGvnn1J6-jctfe_AZZyyqw4Mol4lAq8UruQi8xRbNoRo_9H23SjcGrdyV2vh9wMsqXALXw-LWpWDL37L0kA&amp;t=AQILF4HGUw7R_1vSN0M\" width=\"100%\" height=\"450\" scrolling=\"yes\" style=\"border: none;\"></iframe>",
    //     "unit":"TWD"
    //   },
    //   "1_素材0002":{
    //     "title":"b素材",
    //     "content":"<iframe src=\"https://www.facebook.com/ads/api/preview_iframe.php?d=AQIeAzNYWHdjGt7HTpApIJptJjQA13g5LwY6OrkdH7NbEsOiMcw8aZ6vibvi9lRxzYbdrYmhB1-GPqTyFDYaa6IALNu7EgV_xp0rJsA_bQNzJCEQzEDC8ziZ_-CHOUNAAYbLrDLcP2474B6Hv9uNV-_wmijO-S2gGq6omprO5sWz1RbkUob86H9-w9zJ_XeitVasa9_GSR1mjTPDCNqCX0a8LImtSwtFmT2Q67Iw20KoF3RFgnccpS24_qoWx_8zflHvqJqQSBDsCGvwkbvnaZfWAzua5YQ7s46m_pr7pk-zXQ-YNseZzGIxAIFEqB6Uetrm4w6gAGk3LxRxTEtHZvrAcIWzE0pwXjxYMmgCPMZ8-ksP5WZvRai-y1lwRSdwEkeuGkWinAixZL5gfiRxGnSwevun7BADUEnSpmXLIEzHFeJU2VpCfKDXUSrTOHlRSkeETfnJd8DUIDQMCux3fGb2sjpmJaI1ad09Q8GT1VE_v2cv9c3FzFnfG_dbiettD0iqgJWraCDfIoeJy3Ci25zC2OVaqyq71pAcYvt2nUolGscTM0tKhQuNogrfEo5ylk4&amp;t=AQKKVddbeR8MIOa9CQw\" width=\"100%\" height=\"450\" scrolling=\"yes\" style=\"border: none;\"></iframe>",
    //     "unit":"USD"
    //   },
    //   "2_素材0003":{
    //     "title":"c素材",
    //     "content":"<iframe src=\"https://www.facebook.com/ads/api/preview_iframe.php?d=AQLvYv0jDfMRRRsqK1hieMBoyGrVcjHt8UE5L1-JcliWqfQ94F0f2AQp2oC8Rw25qWU22iScHvC9dBgbH3NIdse83PK2cL3PlP5V-PCtUXkiKzARwFHZN2ONZoazGTAAD1Mp8tzUd59LcN_ORRI4DUmQoZjSTXWHRZ3pwuZAbymXTH8lfT3LDYV4VxIMRkNw1cndF2BwyMCP9rHGOzL-DooiRE7EbNb-sofo4uBs-_kU-5bh7VIxMFZCKF4fimVoU72h0Q_OfsLk7bXpugE7eRE4mUnncSNIAu9Xu1rRZW19aPszOCrQa6nmxTK8r3Io6R77Oz3hJuiCO8gjER3qpP0HB4Pte5i9L8gR1FvmCyLSKmEn9BP6Poh58mnbuA2i-ads9EVLMCqrRCe8ygd8IDKAP6YBFfQ7Z9CSkAhZCyCbL_TEq4SkkuDXcWMRb3Lqi4mRewcuK2hifWVgDaUtF2qZroVs-T8xYRJHhCoTXgJDVfRw_3KOQ2f4gjGYHGaASfbyNcmM-j8D06XTYegyn0sSVZKukKq_Bm6yPJrErEoFl21fBOJCJMSnRj3ycmbckcE&amp;t=AQJXlvV1R50lJdYkdH4\" width=\"100%\" height=\"450\" scrolling=\"yes\" style=\"border: none;\"></iframe>",
    //     "unit":"TWD"
    //   },
    //   "3_素材0004":{
    //     "title":"d素材",
    //     "content":"<iframe src=\"https://www.facebook.com/ads/api/preview_iframe.php?d=AQKm1YoO7APl09zLIJDmffExCHHKvVIUDErAJ7wo1Qb6zUCxELJnplxFnj16qUBCkTJm98SNA7DZmJF8aZtefQsCdRuXPePUD64UW2dp2Dg2MHKJuKVJwBIKXlGRwoj7C0XZEqHs52XekW-m5jl0wsekU6EXQWVoWLrqyAHZ1lYO4fpjMwnyH17aZIQ4i0i1DJCF7x1d0oEjT3jj2zwoOjNaT6sL2qWPlKglLh6F40E78kObW3Whz0REq6Y3spKvjd01PQZTmQLdDom5aSi69fKkkGbMfLSyvKa1i5z1gyJykfGXFOZAoxD9F6Hukmzwc6Zgm75z07ut0DGM1UgPplAAEczrscoMVu8yN_29gjXpBVQBxFhUma7UH6km2HZaNLw-0HyhESiemQJ51tbe6JvKLVD4ypnbIZWTVv19OjQKAk2BLAY35CF2_u_-D3A5rBFpwa_vciJ5Luw0h86CxVUiAQNlExDZxSTlWu73vcRWW3Jeh-_nIwmk_4lgZjlWvm4PRMZMShv79p2jBAEnxRNAXgj4I8-UM3AVxyIQcutgexFKy4Cg_dAenO0wjnHN64A&amp;t=AQJZI0r_HbJ_tlZMgj8\" width=\"100%\" height=\"450\" scrolling=\"yes\" style=\"border: none;\"></iframe>",
    //     "unit":"USD"
    //   }
    // };

    // const finTableData = props.tableData;
    const finTableData = computed(() => {
      // chartRef.value.update();
      // console.log('props.tableData');
      // console.log(props.tableData);
      return props.tableData
    });

    // const finTableData = {
    //   "0_a素材":
    //   [
    //     {
    //       "since" : "2022/1/1 12:00:00",
    //       "until" : "2022/1/1 13:00:00",
    //       "title" : "aaa"
    //     }
    //   ],
    //   "1_b素材":[
    //     {
    //       "since" : "2022/1/1 12:00:00",
    //       "until" : "2022/1/1 13:00:00",
    //       "title" : "aaa"
    //     },
    //     {
    //       "since" : "2022/1/2 12:00:00",
    //       "until" : "2022/1/2 13:00:00",
    //       "title" : "bb"
    //     }
    //   ],
    //   "2_c素材":
    //   [
    //     {
    //       "since" : "2022/1/1 12:00:00",
    //       "until" : "2022/1/1 13:00:00",
    //       "title" : "aaa"
    //     }
    //   ],
    //   "3_d素材":
    //   [
    //     {
    //       "since" : "2022/1/1 12:00:00",
    //       "until" : "2022/1/1 13:00:00",
    //       "title" : "aaa"
    //     },
    //     {
    //       "since" : "2022/1/2 12:00:00",
    //       "until" : "2022/1/2 13:00:00",
    //       "title" : "bb"
    //     }
    //   ]
    // };

    const basicOptions = computed(() => ({
      scales: {
          xAxes: [
              {
                  stacked: true,
                  ticks: {
                      callback: function(value, index, ticks) {
                          return value+"%";
                      }
                  }
              }
          ],
          yAxes: [
              {
                  stacked: true,
                  barPercentage: 0.6,
                  // categoryPercentage: 1,
                  // maxBarThickness:20,
                  // barThickness:200,
              }
          ]
      },
      onClick(i, e) {
        // console.log(i);
        // console.log(e);
        // console.log(e[0]._index);
        // console.log(e[0]._view.label);
        let key = e[0]._index+'_'+e[0]._view.label;
        let materialList = props.chartPrview

        // console.log('onClick materialList');
        // console.log(props.chartPrview);
        // console.log('key');
        // console.log(key);

        let html_content = props.lang['components']['Report']['Charts']['MaterialChartPanel']['basicOptions_onClick_html_content']
        if(materialList[key].content != ''){
          html_content = materialList[key].content
        }

        Swal.fire({
              icon: '',
              title: materialList[key].title,
              html: html_content,
              confirmButtonColor: '#9D9D9D',
              confirmButtonText: props.lang['components']['Report']['Charts']['MaterialChartPanel']['basicOptions_onClick_swal_confirmButtonText']
            });
      },
      legend: {
        display: false,
        onClick: function(e, legendItem) {
          let index = legendItem.datasetIndex;
          let ci = this.chart;
          let meta = ci.getDatasetMeta(index);

          // See controller.isDatasetVisible comment
          if (legendItem.text !== undefined && legendItem.text !== '優化建議') {
            meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;
          }
          // We hid a dataset ... rerender the chart
          // console.log('material chart update');
          ci.update();
        },
      },
      tooltips: {
          callbacks: {
             label: function(tooltipItem) {
                // console.log('material tooltipItem');
                // console.log(tooltipItem);
                let key = tooltipItem.index+'_'+tooltipItem.yLabel;

                // let _tmp_tableData = materialList[key].info
                // let _tmp_unit = materialList[key].unit

                // const finTableData = _tmp_tableData

                listKey.value = key

                // console.log('props.tableData');
                // console.log(props.tableData);
                // console.log('materialList['+key+'].info');
                // console.log(materialList[key].info);
                // console.log('listKey');
                // console.log(listKey);
                // return tooltipItem.xLabel+'（'+_tmp_unit+'）';
                return props.lang['components']['Report']['Charts']['MaterialChartPanel']['tooltips_callbacks_label']+tooltipItem.xLabel+"%";
             }
          }
      },
      responsive: true,
      maintainAspectRatio: false,
      // aspectRatio: 50
    }));

    // const lineStylesData = computed(() => {

    //   console.log('props.chartsData');
    //   console.log(props.chartsData);
    //   if (props.tableData.length <= 0) {
    //     return props.chartsData;
    //   } else {
    //     // 圖畫最大值
    //     const maxDataArray = [];
    //     props.chartsData.datasets.map((e) => {
    //       maxDataArray.push(Math.max(...e.data.map(p => p.y)));
    //     });
    //     const maxData = 20 - Math.max(...maxDataArray) % 20 > 0 ? Math.max(...maxDataArray) + 20 - Math.max(...maxDataArray) % 20 : Math.max(...maxDataArray);

    //     let optimizeDatasets = [];
    //     for (let idx = 0; idx < props.tableData.length; idx++) {
    //       // Since Data
    //       let sinceItem = {
    //         data: [
    //           {
    //             x: new Date(props.tableData[idx].since),
    //             y: 0
    //           },
    //           {
    //             x: new Date(props.tableData[idx].since),
    //             y: maxData
    //           }
    //         ],
    //         pointRadius: 0,
    //         fill: false,
    //         borderColor: props.tableData[idx].borderColor,
    //         pointHoverRadius: 0,
    //         tension: .4,
    //         showLine: true
    //       }

    //       let untilItem = {
    //         data: [
    //           {
    //             x: new Date(props.tableData[idx].until),
    //             y: 0
    //           },
    //           {
    //             x: new Date(props.tableData[idx].until),
    //             y: maxData
    //           }
    //         ],
    //         pointRadius: 0,
    //         fill: false,
    //         borderColor: props.tableData[idx].borderColor,
    //         pointHoverRadius: 0,
    //         tension: .4,
    //         showLine: true
    //       }

    //       // if (idx === 0) {
    //       //   sinceItem.label = '優化建議';
    //       // }
    //       optimizeDatasets.push(sinceItem);
    //       optimizeDatasets.push(untilItem);
    //     }
    //     let finial = {...props.chartsData};
    //     finial.datasets = [...optimizeDatasets, ...finial.datasets];
    //     console.log(finial);
    //     return finial;
    //     // return props.chartsData;
    //   }

    // });

    const lineStylesData = computed(() => {
      // chartRef.value.update();
      //console.log('props.chartsData');
      //console.log(props.chartsData);

      return props.chartsData
    });
    // const lineStylesData = props.chartsData;

    //console.log('material lineStylesData');
    //console.log(lineStylesData);


    const langData = computed(() => {
      // chartRef.value.update();
      //console.log('props.lang');
      //console.log(props.lang);

      return props.lang
    });

    // const lineStylesData = {
    //     labels: ["a素材", "b素材", "c素材", "d素材"],
    //     datasets: [{
    //         label: '',
    //         data: [12, 19, 3, 5],
    //         backgroundColor: [
    //             'rgba(255, 99, 132, 0.2)',
    //             'rgba(54, 162, 235, 0.2)',
    //             'rgba(255, 206, 86, 0.2)',
    //             'rgba(75, 192, 192, 0.2)',
    //         ],
    //         borderColor: [
    //             'rgba(255,99,132,1)',
    //             'rgba(54, 162, 235, 1)',
    //             'rgba(255, 206, 86, 1)',
    //             'rgba(75, 192, 192, 1)',
    //         ],
    //         borderWidth: 1
    //     }]
    // };

    const showReport = () => {
      reportShow.value = true;
    };

    const hideReport = () => {
      reportShow.value = false;
    };

    return {
      reportShow,
      lineStylesData,
      basicOptions,
      showReport,
      hideReport,
      finTableData,
      listKey,
      langData
    }
  },
  // data() {
  //   return {
  //     lineStylesData: {},
  //     finTableData: {}
  //   }
  // },
  // methods: {
  //   item_click() {
  //     Swal.fire({
  //             icon: '',
  //             title: '標題',
  //             html:'<iframe src="https://www.facebook.com/ads/api/preview_iframe.php?d=AQIgRk-i8q3pfR_kTNfOIlLGLNpsiXJ_Vb5rGN3Lg4NZlXHEEDS1SoczkIx4XOvvQ9QfUaED_tGGpe09JKsdNPsv1OAtSC7Vz9Z2JVPGpZZ9RbQ2HVSQAgiN2sQarywQlAZRipObewLCh_qEMnnqeEhARei8dttuK3QX1rXXkW9fDy7iK1WnXGntL293WtOFymL_4Sn086DmDYyf_th4HFHTxAKULn0GEGq2feJEa7WdjOvhIlDyF0dkEvRhHVcw9jx0YYxdlH-4qYFEEVnJYZ3S0wjK_XC15Q39a8bUrc5W2r5nEjf5YkVuLeUDYwiIBnn7KzfHkXcptgbGNiuD-m9gWUd24vBP0s7i3y4L_A6hVZQ9YBkEgdiDLu6Bl7FqTXWma92lsH4NN41oevzTKXThCN3vCTM6D9c9_j9l9VI4pr_GgZxt_wOnlC2sHdOQR81G7rqXfcd7WrDC21RmPpCUIW9HfYdH6NgItICk9DwNrmUXwvke_nl35T52EhaYzGxRkhCNznbkxJfSYyV_f4YMSPwdAfcOEOd1wXFw415z7kbuXrAO3MtNOon0Xylc7M0&amp;t=AQL-RTtDCrwWhX33xJw" width="100%" height="450" scrolling="yes" style="border: none;"></iframe>',
  //             confirmButtonColor: '#9D9D9D',
  //             confirmButtonText: '關閉'
  //           });
  //   }
  // },
  // watch:{
  //   'chartPrview'(value){
  //     console.log('chartPrview');
  //     console.log(value);
  //   },
  //   'chartsData'(value){
  //     console.log('chartsData');
  //     console.log(value);

  //     this.lineStylesData = value

  //     console.log('this.lineStylesData');
  //     console.log(this.lineStylesData);
  //   },
  //   'tableData'(value){
  //     console.log('tableData');
  //     console.log(value);

  //     this.finTableData = value

  //     console.log('this.tableData');
  //     console.log(this.tableData);
  //   }
  // }
};
</script>

<style lang="css" scoped>

.panel {
  width: 100%;
  height:100%;
}

</style>
